import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import LoadingSpinner from '../components/LoadingSpinner';
import { consumeGoogleAuthRedirect } from '../utils/googleAuth';

const GoogleAuthSuccess = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [, setCookie] = useCookies(['access_token']);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const token = params.get('token');
        const userID = params.get('userID');
        const username = params.get('username');
        const isPowerUser = params.get('isPowerUser') === 'true';

        if (!token || !userID) {
            navigate('/auth/login?error=google-auth-failed', { replace: true });
            return;
        }

        const hostname = window.location.hostname;
        const isProduction = hostname !== 'localhost' && hostname !== '127.0.0.1';

        setCookie('access_token', token, {
            path: '/',
            maxAge: 7 * 24 * 60 * 60,
            sameSite: 'lax',
            secure: isProduction,
            ...(isProduction && hostname.includes('.') && {
                domain: hostname.startsWith('www.') ? hostname.substring(4) : hostname,
            }),
        });

        localStorage.setItem('userID', userID);
        localStorage.setItem('auth_token', token);
        if (username) localStorage.setItem('username', username);
        localStorage.setItem('isPowerUser', isPowerUser ? 'true' : 'false');
        localStorage.setItem('preferredRegion', params.get('preferredRegion') || '');
        localStorage.setItem('vitalityFirst', params.get('vitalityFirst') === 'true' ? 'true' : 'false');

        window.dispatchEvent(new Event('auth-token-updated'));

        const redirectPath = consumeGoogleAuthRedirect(params.get('redirect'));
        const isMcpFlow = redirectPath?.startsWith('/authorize') || redirectPath?.startsWith('/mcp/connect');

        navigate(redirectPath || '/searchrecipes', {
            replace: true,
            state: isMcpFlow ? { fromGoogleMcpAuth: true } : undefined,
        });
    }, [location, navigate, setCookie]);

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            textAlign: 'center',
            padding: '1rem',
            background: 'linear-gradient(to bottom right, #fff7ed, #ffedd5)',
        }}>
            <LoadingSpinner size="lg" color="primary" />
            <h2 style={{
                marginTop: '20px',
                fontSize: window.innerWidth <= 768 ? '1.25rem' : '1.5rem',
                color: '#374151',
                fontWeight: '600',
            }}>
                Finalizing your secure login...
            </h2>
        </div>
    );
};

export default GoogleAuthSuccess;
